import { createFileRoute } from '@tanstack/react-router';

import { BlockedUsers } from '#modules/user/features/profile/components/Settings/BlockedUsers';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/blocked'
)({
  component: BlockedUsers,
  ssr: false,
});
